import React, { Component } from 'react';

class SettingValue extends Component {
  render() {
    return (
      <div className="form-group row">
        <div className="col-md-4">
          <label htmlFor="type" className=" w-100 rsee-form-label">
            {this.props.title}
          </label>
        </div>
        <div className="col-md-8">
          <div className="input-group">
            <input
              id={this.props.id}
              name={this.props.id}
              type="text"
              className={`form-control ${this.props.valueInputValidateStatus}`}
              value={this.props.value}
              autoComplete="off"
              onChange={this.props.onValueChange}
            />
            <div className="input-group-append">
              <span className="input-group-text">{this.props.description}</span>
            </div>
            <div className="invalid-feedback">{this.props.valueInputInvalidMessage}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default SettingValue;
